var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicsvgDownload19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "286.000000pt",
    viewBox: "0 0 300.000000 286.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,286.000000) scale(0.050000,-0.050000)",
    fill: "#dc474f",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3906 5654 c-7 -11 -2 -14 10 -7 11 8 27 5 33 -5 6 -11 3 -25 -9 -32 -11 -7 -20 -23 -19 -36 0 -15 10 -12 25 7 13 18 42 43 64 56 38 23 37 24 -8 12 -27 -8 -42 -5 -35 6 6 10 -2 18 -19 18 -16 0 -35 -9 -42 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2174 4509 c-792 -178 -1219 -968 -882 -1633 527 -1039 2172 -861 2437 264 188 801 -680 1565 -1555 1369z m640 -138 c1061 -337 1083 -1627 34 -2012 -248 -91 -565 -78 -875 35 -173 64 -493 318 -493 392 0 10 -17 42 -37 71 -123 176 -174 598 -95 793 247 606 866 911 1466 721z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1948 3691 c-130 -56 -123 -255 11 -311 122 -50 221 33 221 187 0 107 -122 172 -232 124z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2835 3696 c-71 -25 -84 -244 -18 -303 139 -126 341 105 218 250 -53 62 -123 81 -200 53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2329 3148 c-250 -51 -480 -232 -408 -319 35 -43 46 -38 153 66 209 204 605 199 783 -9 89 -104 143 -107 143 -7 0 165 -400 326 -671 269z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3755 2727 c-89 -63 -123 -150 -95 -245 17 -60 13 -74 -29 -117 -60 -60 -78 -138 -61 -264 8 -61 5 -102 -8 -110 -27 -16 -29 -210 -3 -277 27 -73 118 -94 406 -94 l260 0 -12 -55 c-45 -219 -52 -288 -41 -385 24 -204 107 -280 305 -280 124 0 153 27 171 160 22 163 96 342 220 527 313 471 282 974 -71 1154 -68 35 -120 39 -521 39 l-446 0 -75 -53z m981 -95 c52 -26 108 -64 126 -85 117 -139 100 -652 -28 -791 -86 -94 -153 -193 -182 -269 -68 -179 -112 -322 -123 -391 -18 -125 -134 -121 -201 8 -44 84 -23 363 33 448 102 154 36 188 -361 188 -342 0 -360 6 -360 113 0 85 45 109 227 119 243 14 245 113 2 124 -156 7 -189 25 -189 105 0 84 48 119 160 119 100 0 200 27 200 55 -1 47 -48 75 -144 84 l-106 11 5 78 c8 133 6 132 448 132 380 0 403 -2 493 -48z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicsvgDownload19);
export default __webpack_public_path__ + "static/media/picsvg_download (19).9af9712c4955d192ff0082ccf1dde13a.svg";
export { ForwardRef as ReactComponent };